'use client'

import Head from 'next/head'

import AccountAccount from '@/components/account/AccountAccount'
import AccountDangerZone from '@/components/account/AccountDangerZone'

const Account = () => {
  return (
    <>
      <Head>
        <title>Account</title>
        <meta name="description" content="Account" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="grid grid-cols-2">
        <AccountAccount className="col-span-2 lg:col-span-1" />
        <AccountDangerZone className="col-span-2 lg:col-span-1" />
      </div>
    </>
  )
}

export default Account
